// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// "require" forces the load of code in the order in which is written
// "import" lines can be reorder by the intrerpreter/cpu/whatever.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require ("bootstrap-datepicker")

require("select2");
var jquery = require("jquery");

// use global.Abc = Abc if you want not to be importing Abc multiple times
//------------------------------------------------------------------------
global.$ = jquery;
// global.select2 = select2;

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

require("../custom-code/invoice-filters");
require("../custom-code/invoice-retry");
require("../custom-code/one_submit_actions_per_input");

// Initialize dayjs configuration (Spanish locale with capitalized months)
require("../utils/dayjs-config");
